import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { appointmentsApi } from "../Components/appointmentsApi";

const initialState = {
  items: [],
  types: [],
  pagination: { page: 1, per_page: 20, total: 0, pages: 1 },
  loading: false,
  error: "",
  lastQuery: {},
};

export const fetchAppointments = createAsyncThunk(
  "appointments/fetchAppointments",
  async (params = {}, { rejectWithValue }) => {
    try {
      const data = await appointmentsApi.listAppointments(params);
      if (data?.error) {
        return rejectWithValue(data.error);
      }
      return data;
    } catch (error) {
      return rejectWithValue(error.message || "Failed to load appointments");
    }
  }
);

export const fetchAppointmentTypes = createAsyncThunk(
  "appointments/fetchTypes",
  async (_, { rejectWithValue }) => {
    try {
      const data = await appointmentsApi.getTypes();
      if (data?.error) {
        return rejectWithValue(data.error);
      }
      return data.appointment_types || [];
    } catch (error) {
      return rejectWithValue(error.message || "Failed to load appointment types");
    }
  }
);

const appointmentsSlice = createSlice({
  name: "appointments",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAppointments.pending, (state, action) => {
        state.loading = true;
        state.error = "";
        state.lastQuery = action.meta.arg || {};
      })
      .addCase(fetchAppointments.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload?.appointments || [];
        state.pagination = action.payload?.pagination || initialState.pagination;
      })
      .addCase(fetchAppointments.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message || "Failed to load appointments";
      })
      .addCase(fetchAppointmentTypes.fulfilled, (state, action) => {
        state.types = action.payload || [];
      });
  },
});

export default appointmentsSlice.reducer;
